import { useCallback, useEffect, useRef, useState } from "react"

export function useAsyncEffect(cb: (opts: { isAlive(): boolean }) => void, updateOn?: any[]) {
  const traceRef = useRef<string | undefined>()
  traceRef.current = new Error().stack

  const throwError = useAsyncError()

  useEffect(() => {
    const isAlive = { current: true }
    const fn = async () => {
      await Promise.resolve(cb({ isAlive: () => isAlive.current }))
    }
    fn().catch(e => {
      console.error(e)
      throwError(e, traceRef.current)
    })

    return () => {
      isAlive.current = false
    }
  }, updateOn)
}

const useAsyncError = () => {
  const [_, setError] = useState()
  return useCallback(
    (e, stackTrace?: any) => {
      setError(() => {
        if (stackTrace) {
          const formattedError = new Error(e.message)
          formattedError.stack = stackTrace
          console.error(formattedError.message)
          throw formattedError
        } else {
          throw e
        }
      })
    },
    [setError],
  )
}
